import * as yup from 'yup';
import { verificaCorreoRegistrado } from '../helpers/verificaCorreoRegistrado';
import { DICTONARY } from 'const/Dictonary';
import debounce from 'lodash/debounce';

const emailRegex = DICTONARY.EMAIL_REGEX;

// Función debounced para la validación del correo
const debouncedCheckEmail = debounce(async (email, setIsLoadingEmail) => {
  setIsLoadingEmail(true);
  const isRegistered = await verificaCorreoRegistrado(email);
  setIsLoadingEmail(false);
  return !isRegistered; // Retorna true si el correo es válido
}, 500); // Tiempo de espera en ms

const schemaSignUp = yup.object().shape({
  name: yup
    .string()
    .trim()
    .matches(
      /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+\s[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+\s[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/,
      'El nombre debe contener al menos el primer nombre, apellido paterno y apellido materno'
    )
    .required('Este campo es requerido'),

  email: yup
    .string()
    .trim()
    .matches(emailRegex, 'El correo electrónico no tiene el formato correcto')
    .required('El correo electrónico es requerido')
    .test(
      'Evaluación de correo',
      'El correo electrónico ingresado está registrado',
      async function (value) {
        const correo = value.trim();
        const { parent } = this;

        const emailModificado = parent.emailModificado || false;
        const setIsLoadingEmail = parent.setIsLoadingEmail || (() => {});
        const setEmailError = parent.setEmailError || (() => {});
        const lastValidatedEmail = parent.lastValidatedEmail || null;

        // Si el correo no fue modificado o es el mismo validado previamente, no verifica
        if (!emailModificado || correo === lastValidatedEmail) {
          return correo !== lastValidatedEmail; // Devuelve el último estado válido
        }

        // Limpiar error previo y actualizar estado de carga
        setEmailError(null);
        setIsLoadingEmail(true);

        // Validar con debounce
        const isValid = await debouncedCheckEmail(correo, setIsLoadingEmail);
        setIsLoadingEmail(false);

        if (!isValid) {
          setEmailError('El correo electrónico ingresado está registrado');
        }

        return isValid;
      }
    ),

  password1: yup
    .string()
    .trim()
    .test(
      'length',
      'La contraseña debe tener al menos 8 caracteres',
      value => value.length >= 8
    )
    .matches(/([0-9])/, 'numero')
    .matches(/([A-Z])/, 'mayuscula')
    .matches(/([a-z])/, 'minuscula')
    .matches(/([!@#$%^&*(),.?":{}|<>])/, 'caracter')
    .required('La contraseña es requerida'),

  password2: yup
    .string()
    .trim()
    .oneOf([yup.ref('password1'), null], 'Las contraseñas no coinciden')
    .required('Confirme la contraseña'),

  terminosYCondiciones: yup
    .boolean()
    .oneOf(
      [true],
      'Debes aceptar los términos y condiciones y la politica de privacidad'
    )
    .required(
      'Debes aceptar los términos y condiciones y la politica de privacidad'
    ),

  consentimientoDatos: yup
    .boolean()
    .oneOf([true], 'Debes aceptar el consentimiento expreso informado')
    .required('Debes aceptar el consentimiento expreso informado')
});

export { schemaSignUp };
